import yup from '../yup-extended';
import { BuildingPart, BuildingPartDetail, BuildingType } from '@cobra/interfaces-enums-mocks/enums';

export const buildingTypeSchema = yup
    .string()
    .nullable()
    .trim()
    .label('Gebäudetyp')
    .optionalOneOf(Object.values(BuildingType));
export const buildingPartSchema = yup
    .string()
    .nullable()
    .trim()
    .label('Lage')
    .optionalOneOf(Object.values(BuildingPart));
export const buildingPartDetailSchema = yup
    .string()
    .nullable()
    .trim()
    .label('Details')
    .optionalOneOf(Object.values(BuildingPartDetail));
export const buildingFloorSchema = yup.string().nullable().trim().label('Stockwerk').max(10);
export const buildingPartNotesSchema = yup.string().nullable().trim().label('Weitere Details').max(255);
